var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMessageinfo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(6575 12230)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-6575 -12230)",
    stroke: "#6a92c5",
    fill: "none"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 7,
    cy: 7,
    r: 7,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 7,
    cy: 7,
    r: 6.5
  })), /*#__PURE__*/React.createElement("rect", {
    fill: "#6a92c5",
    width: 1,
    height: 6,
    rx: 0.5,
    transform: "translate(-6568.5 -12225)"
  }), /*#__PURE__*/React.createElement("rect", {
    fill: "#6a92c5",
    width: 1,
    height: 1,
    rx: 0.5,
    transform: "translate(-6568.5 -12227)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMessageinfo);
export default __webpack_public_path__ + "static/media/messageinfo.a6fb46c5.svg";
export { ForwardRef as ReactComponent };